const state = {
  axiosCancelList: []
}

const mutations = {
  //设置请求列表
  setAxiosList: (state, cancel) => {
    state.axiosCancelList.push({ f: cancel })
  },

  //取消全部请求
  clearAllAxiosList: state => {
    if (!state.axiosCancelList.length) return
    state.axiosCancelList.forEach(item => {
      item && item.f()
    })
    state.axiosCancelList = []
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/axiosPromiseCancel.js